module.exports = __webpack_public_path__ + "static/img/yellow_btn.30b578b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ko/yellow_btn.png
// module id = jPzl
// module chunks = 1